// Brand assets — DOTAPAN DIN 2019 (updated)
export const LOGO_MAIN = "https://customer-assets.emergentagent.com/job_transylvanian-bread/artifacts/663w2zyg_Logo%20Dotapan%202019%202026.png";
export const LOGO_HORECA = "https://customer-assets.emergentagent.com/job_transylvanian-bread/artifacts/fpt0ndg8_Logo%20Dotapan%202019%202026%2033.png";
export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_transylvanian-bread/artifacts/3z7c0k6c_Dotapan%202019%202026.png";

// Real DOTAPAN product photos (hosted locally in /public/products/)
const P = "/products/";

export const SALEURI_IMG = P + "saleuri-cu-chimen.jpg";
export const FROZEN_IMG = P + "produse-congelate-dotapan.jpg";

export const IMG = {
  croissantArtisan: P + "croissant-cu-unt.jpg",
  croissantTray: P + "croissant.jpg",
  croissantCongelat: P + "croissant-congelat-cu-unt.jpg",
  miniCroissant1: P + "produs-congelat-croissant-cu-unt- (1).jpg",
  miniCroissant2: P + "produs-congelat-croissant-cu-unt- (2).jpg",
  miniCroissant3: P + "produs-congelat-croissant-cu-unt-.jpg",
  pizzaBase: P + "blat-de-pizza-congelat-resize.jpg",
  pizzaDough: P + "blat-de-pizza-congelat-resize.jpg",
  foietaj: P + "aaluat-foietaj-gramaj-variat.jpg",
  trigon: P + "trigon-cu-branza-produs-congelat.jpg",
  strudel: P + "strudel-congelat-diverse-umpluturi.jpg",
  strudelMere: P + "strudelcumeresivisine.jpg",
  placinta: P + "placinta-cu-visine.jpg",
  rulou: P + "rulou-cu-cabanos-produs.jpg",
  chifla: P + "chifla-cu-seminte-gramaj-variat.jpg",
  eclere: P + "appetizer-bake-baked-372851-1-558x607.jpg",
  cornulete: P + "Apple_Pie_hero.png",
  fursecuri: P + "abundance-baked-baked-goods-3082785-1-264x221.jpg",
  patiserieProaspata: P + "patiserie-proaspata.jpg",
  patiserieCongelata: P + "patiserie-congelata.jpg",
  panificatie: P + "panificatie.jpg",
  cofetarie: P + "cofetarie.jpg",
  calitate: P + "calitate.jpg",
  faina: P + "faina-1.png",
  bakeryAmbient: P + "panificatie.jpg",
  doughKneading: P + "blat-de-pizza-congelat-resize.jpg",
  ovenBaking: P + "calitate.jpg",
  ingredients: P + "faina-1.png",
  pastry1: P + "saleuri-cu-chimen.jpg",
  flourSplash: P + "faina-1.png",
};

export const PRODUCTS = [
  {
    id: "croissant-unt",
    name: "Croissant cu unt",
    type: "copt",
    image: IMG.croissantArtisan,
    benefit: "Straturi fine, gust bogat și aspect frumos în vitrină.",
    weight: "60g",
    category: "Croissante",
  },
  {
    id: "croissant-congelat-100",
    name: "Croissant congelat cu unt",
    type: "congelat",
    image: IMG.croissantCongelat,
    benefit: "Coace-l la momentul potrivit. Prospețime ca în prima zi.",
    weight: "100g",
    category: "Croissante",
  },
  {
    id: "mini-croissant-25",
    name: "Mini croissant cu unt",
    type: "congelat",
    image: IMG.miniCroissant1,
    benefit: "Perfect pentru coffee corner, bufet sau servire rapidă.",
    weight: "25g",
    category: "Croissante",
  },
  {
    id: "mini-croissant-50",
    name: "Mini croissant cu unt",
    type: "congelat",
    image: IMG.miniCroissant2,
    benefit: "Format ideal pentru mic dejun și pauze de cafea.",
    weight: "50g",
    category: "Croissante",
  },
  {
    id: "blat-pizza-250",
    name: "Blat pizza congelat",
    type: "congelat",
    image: IMG.pizzaBase,
    benefit: "Bază practică, elastică și gustoasă. Constantă lot după lot.",
    weight: "250g",
    category: "Blat pizza",
  },
  {
    id: "aluat-foietaj",
    name: "Aluat foietaj",
    type: "congelat",
    image: IMG.foietaj,
    benefit: "Versatil pentru produse dulci și sărate. Gramaj variat.",
    weight: "1 kg",
    category: "Aluat foietaj",
  },
  {
    id: "trigon-branza",
    name: "Trigon cu brânză",
    type: "congelat",
    image: IMG.trigon,
    benefit: "Snack rapid, savuros, ideal pentru mic dejun.",
    weight: "90g",
    category: "Patiserie",
  },
  {
    id: "strudel-umpluturi",
    name: "Strudel cu umpluturi variate",
    type: "congelat",
    image: IMG.strudel,
    benefit: "Stratificare fină, umpluturi savuroase, gust care rămâne.",
    weight: "120g",
    category: "Patiserie",
  },
  {
    id: "strudel-mere-visine",
    name: "Strudel cu mere și vișine",
    type: "congelat",
    image: IMG.strudelMere,
    benefit: "Combinație clasică, parfumată, ideală pentru vitrină.",
    weight: "120g",
    category: "Patiserie",
  },
  {
    id: "placinta-visine",
    name: "Plăcintă cu vișine",
    type: "copt",
    image: IMG.placinta,
    benefit: "Aluat fraged, vișine acrișoare. Vânzare sigură toată ziua.",
    weight: "150g",
    category: "Patiserie",
  },
  {
    id: "rulou-cabanos",
    name: "Rulou cu cabanos",
    type: "copt",
    image: IMG.rulou,
    benefit: "Hot snack rapid, gustos, perfect pentru fast-food și bufet.",
    weight: "120g",
    category: "Patiserie",
  },
  {
    id: "chifla-seminte",
    name: "Chiflă cu semințe",
    type: "copt",
    image: IMG.chifla,
    benefit: "Bază premium pentru burgeri, sandvișuri și gustări calde.",
    weight: "Gramaj variat",
    category: "Panificație",
  },
  {
    id: "saleuri-chimen",
    name: "Saleuri cu chimen",
    type: "copt",
    image: SALEURI_IMG,
    benefit: "Gust simplu, bun, ideal pentru retail și evenimente.",
    weight: "140g",
    category: "Patiserie",
  },
  {
    id: "coji-mini-eclere",
    name: "Coji mini eclere",
    type: "copt",
    image: IMG.eclere,
    benefit: "Ușor de umplut, frumoase la prezentare.",
    weight: "10g/buc",
    category: "Cofetărie",
  },
  {
    id: "cornulete-marmelada",
    name: "Cornulețe cu marmeladă",
    type: "copt",
    image: IMG.cornulete,
    benefit: "Mușcătură moale, dulce și umpluturi de încredere.",
    weight: "40g",
    category: "Patiserie",
  },
  {
    id: "fursecuri-unt",
    name: "Fursecuri cu unt",
    type: "copt",
    image: IMG.fursecuri,
    benefit: "Crocante, parfumate, potrivite pentru vitrine elegante.",
    weight: "500g",
    category: "Cofetărie",
  },
];

export const CATEGORIES = [
  {
    id: "coapte",
    name: "Produse coapte",
    desc: "Pentru vitrine, cafenele și locații care vor produs finit, frumos și gustos.",
    image: IMG.patiserieProaspata,
  },
  {
    id: "congelate",
    name: "Produse congelate",
    desc: "Pentru bucătării care vor control, prospețime și coacere la momentul potrivit.",
    image: FROZEN_IMG,
  },
  {
    id: "croissante",
    name: "Croissante",
    desc: "Cu unt, stratificate frumos, crocante la exterior și moi în interior.",
    image: IMG.croissantArtisan,
  },
  {
    id: "blat-pizza",
    name: "Blat pizza",
    desc: "Un blat bun nu susține doar toppingul. Susține reputația localului tău.",
    image: IMG.pizzaBase,
  },
  {
    id: "foietaj",
    name: "Aluat foietaj",
    desc: "Versatil, rapid, potrivit pentru produse dulci și sărate.",
    image: IMG.foietaj,
  },
  {
    id: "patiserie",
    name: "Patiserie",
    desc: "Trigone, strudele, saleuri, rulouri și produse care se vând ușor.",
    image: IMG.patiserieCongelata,
  },
  {
    id: "cofetarie",
    name: "Cofetărie",
    desc: "Coji mini eclere, fursecuri și produse pentru vitrine elegante.",
    image: IMG.cofetarie,
  },
];

export const COUNTIES = [
  "Bistrița-Năsăud", "Cluj", "Maramureș", "Sălaj", "Mureș", "Sibiu", "Brașov", "Alba", "Hunedoara",
  "Satu Mare", "Bihor", "Timiș", "Arad", "Suceava", "Iași", "Neamț", "Bacău", "București", "Ilfov", "Altul",
];

export const BUSINESS_TYPES = [
  "Restaurant", "Cafenea", "Hotel", "Pizzerie", "Fast-food", "Brutărie", "Magazin / Retail", "Distribuitor", "Altul",
];
